import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import ExpensableDetail from 'modules/expenses/components/expenses/Detail'

import { useExpenses } from './ExpensesContext'

const ExpenseDetailPage = () => {
  const navigate = useNavigate()
  const { expense_id } = useParams()
  const { navigation } = useNavigation()
  const [searchParams] = useSearchParams()
  const { featureAvailabilities, data } = useExpenses()

  const currencies = data?.apiCore?.currencies ?? []
  if (!expense_id) {
    throw new Error('Required expense_id param')
  }

  return (
    <ExpensableDetail
      expensableId={expense_id}
      onClose={() =>
        navigate({
          pathname: navigation.expenses.list.expenses.fullPath(),
          search: searchParams.toString(),
        })
      }
      taxAgencyHomologationEnabled={featureAvailabilities.taxAgencyHomologation}
      reimburseThroughPayrollEnabled={featureAvailabilities.reimburseThroughPayroll}
      reimburseThroughSepaEnabled={featureAvailabilities.reimburseThroughSepa}
      reportOnBehalfEnabled={featureAvailabilities.reportOnBehalf}
      canUseSpendingPolicies={featureAvailabilities.canUseSpendingPolicies}
      hasWorkflowSpendingPolicies={featureAvailabilities.hasWorkflowSpendingPolicies}
      canCreateExpensesForOthers={data.expenses._policies.expenseCreateExpensesForOthers.can}
      canOverrideApprovalFlow={data.expenses._policies.expenseOverrideApprovalFlow.can}
      canSetExpensableToPaid={data.expenses._policies.expenseSetToPaid.can}
      canRestartApprovalFlow={data.expenses._policies.expenseRestartApprovalFlow.can}
      canSeeEmployeeLegalEntity={data.expenses._policies.expenseSeeEmployeeLegalEntity.can}
      canCustomizeSettings={data.expenses._policies.expenseCustomizeSettings.can}
      currencies={currencies}
      accountingTabEnabled
      projectsManagementEnabled={featureAvailabilities.projectsManagement}
      hasCostCentersFeature={featureAvailabilities.costCentersFeature}
    />
  )
}

export default ExpenseDetailPage
